var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-logout"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"is-loading large dark"})])])}]

export { render, staticRenderFns }